import React, {Fragment} from 'react'
import {compose, setDisplayName, withStateHandlers} from 'recompose'
import { getLocaleString } from '../../../../locale'
import { connect } from "react-redux";
import { highlightColors } from "../../../../constants";
import {setOpenAddNote, setSelectedNote} from '../../../../actions/reader'
import { Scrollbars } from "react-custom-scrollbars";
import autosize from 'autosize';
import {equals, cond, T, always} from "ramda";

import './HighlightModal.css'

const mapStateToProps = (state) => ({
  openAddNote: state.reader.openAddNote,
  selectedNote: state.reader.selectedNote
})

const mapDispatchToProps = (dispatch) => ({
  setOpenAddNote: (status) => dispatch(setOpenAddNote(status)),
  setSelectedNote: (note) => dispatch(setSelectedNote(note))
})

const state = ({
  AddNoteTextarea: {},
  EditNoteTextarea: {},
  noteText: ''
})

const stateHandlers = {
  refAddTextarea: () => (textarea) => {
    if (textarea) {
      autosize(textarea)
      textarea.addEventListener('keydown', (e) => e.stopPropagation())
      textarea.focus()
    }
    return {AddNoteTextarea: textarea}
  },
  refEditTextarea: () => (textarea) => {
    if (textarea) {
      autosize(textarea)
      textarea.addEventListener('keydown', (e) => e.stopPropagation())
      textarea.focus()
    }
    return {EditNoteTextarea: textarea}
  },
  onClearTextarea: ({AddNoteTextarea}) => () => {
    if (AddNoteTextarea) AddNoteTextarea.value = ''
    return {noteText: ''}
  },
  onFocusAddTextarea: ({AddNoteTextarea}) => () => {
    autosize.update(AddNoteTextarea)
    setTimeout(() => {
      autosize.update(AddNoteTextarea)
      AddNoteTextarea.focus()
    }, 300)
  },
  onGetAddNoteText: ({AddNoteTextarea}) => () => ({
    noteText: AddNoteTextarea.value
  }),
  onGetEditNoteText: ({EditNoteTextarea}, {selectedNote, setSelectedNote}) => (e) => {
    autosize.update(EditNoteTextarea)
    selectedNote.note.text = e.target.value
    setSelectedNote(selectedNote)
    return {
      noteText: EditNoteTextarea.value
    }
  },
  resize: ({AddNoteTextarea, EditNoteTextarea}) => () => {
    autosize.update(AddNoteTextarea)
    autosize.update(EditNoteTextarea)
  }
}

const enhance = compose(
  setDisplayName('HighlightModal'),
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(state, stateHandlers)
)

const onClickColor = (isUpdate, toggleActiveHighlight, onSelectedColor, color, hexColor, onAddNote, onSelected) => {
  if (!isUpdate) toggleActiveHighlight(false);
  onSelectedColor(color, hexColor);
  onAddNote(onSelected, isUpdate)
}

const Colors = ({onSelectedColor, selectedColor, onSetTextSelected, onAddNote, bookId, addNote, onSelected,
                  toggleActiveHighlight, isUpdate, selectedNote }) => (
  <div className="Highlight_colors">
    {Object.keys(highlightColors).map((key, index) =>
      <Color key={index} color={key} hexColor={highlightColors[key]} onSelectedColor={onSelectedColor} isUpdate={isUpdate}
             selectedColor={selectedColor} onSetTextSelected={onSetTextSelected} onAddNote={onAddNote}
             bookId={bookId} addNote={addNote} onSelected={onSelected} toggleActiveHighlight={toggleActiveHighlight}
             selectedNote={selectedNote}/>)}
  </div>
)

const Color = ({color, hexColor, onSelectedColor, isUpdate, selectedNote,
                 onAddNote, onSelected, toggleActiveHighlight}) => (
  <span className={`Highlight_color ${color}${selectedNote && selectedNote.color && color === selectedNote.color.value ? ' checked' : ''}`} onClick={() => onClickColor(isUpdate, toggleActiveHighlight,
    onSelectedColor, color, hexColor, onAddNote, onSelected)}></span>
)

const createNote = (onUpdateNote, noteText, onSelected, changeHighlighModalPosition,
                    setOpenAddNote, openAddNote, onClearTextarea, toggleActiveHighlight) => {
  if (noteText.length > 0) {
    onUpdateNote(noteText, onSelected, changeHighlighModalPosition);
    setOpenAddNote(!openAddNote);
    onClearTextarea();
    toggleActiveHighlight(false)
  }
  return
}

const OpenEditNote = ({props: {noteText, onUpdateNote, onSelected, changeHighlighModalPosition, setOpenAddNote,
  openAddNote, onClearTextarea, toggleActiveHighlight, onDeleteNote, selectedNote, onGetEditNoteText, refEditTextarea}}) => (
  <div className="Edit__note">
    <div className="Edit__note-header Dropdown__header">
        <span className="Edit__note-header-text">
          {getLocaleString('reader.editNote')}
        </span>
      <button className={`btn btn-add-note icon-btn${noteText.trim().length === 0 ? ' hide' : ''}`} onClick={() => createNote(onUpdateNote, noteText, onSelected, changeHighlighModalPosition,
        setOpenAddNote, openAddNote, onClearTextarea, toggleActiveHighlight)}></button>
      <button className="btn btn-delete-note icon-btn" onClick={() => {onDeleteNote();setOpenAddNote(!openAddNote);onClearTextarea();toggleActiveHighlight(false)}}></button>
      <button className="btn btn-close-white icon-btn" onClick={() => {setOpenAddNote('');toggleActiveHighlight(false);}}></button>
    </div>
    <div className="Second__modal-content">
      <Scrollbars style={{ width: 310, height: 130 }}>
        <textarea ref={(c) => refEditTextarea(c)} id="edit-note-text" className="edit-note-text" value={selectedNote && selectedNote.note ? selectedNote.note.text : ''} onChange={(e) => onGetEditNoteText(e)}></textarea>
      </Scrollbars>
    </div>
  </div>
)

const MainContent = ({props: {onSelectedColor, selectedColor, onSetTextSelected, onAddNote, onSelected,
  toggleActiveHighlight, onFocusAddTextarea, onUpdateNote, noteText, changeHighlighModalPosition, setOpenAddNote,
  openAddNote, onClearTextarea, onGetAddNoteText, refAddTextarea, isUpdate}}) => (
  <Fragment>
    <div className="Main__modal">
      <Colors onSelectedColor={onSelectedColor} selectedColor={selectedColor} onSetTextSelected={onSetTextSelected}
              onAddNote={onAddNote} onSelected={onSelected} toggleActiveHighlight={toggleActiveHighlight} isUpdate={false}/>
      <div className="add-btns">
        <p><button className="add-note-btn" onClick={() => {setOpenAddNote('openAddNote');onFocusAddTextarea()}}>+ {getLocaleString('reader.addNote')}</button></p>
      </div>
    </div>
    <div className="Second__modal">
      <div className="Second__modal-header Dropdown__header">
        <span className="Second__modal-header-text">
          {getLocaleString('reader.addNote')}
        </span>
        <button className={`btn btn-add-note icon-btn${noteText.trim().length === 0 ? ' hide' : ''}`} onClick={() => createNote(onUpdateNote, noteText, onSelected, changeHighlighModalPosition,
          setOpenAddNote, openAddNote, onClearTextarea, toggleActiveHighlight)}></button>
        <button className="btn btn-close-white icon-btn" onClick={() => {onClearTextarea();setOpenAddNote(!openAddNote);onClearTextarea()}}></button>
      </div>
      <div className="Second__modal-content">
        <Scrollbars style={{ width: 235, height: 130 }}>
          <textarea ref={(c) => refAddTextarea(c)} id="add-note-text" className="add-note-text" onChange={() => onGetAddNoteText()}></textarea>
        </Scrollbars>
      </div>
    </div>
  </Fragment>
)

const OpenEditHighlight = ({props: {onSelectedColor, selectedColor, onSetTextSelected, onAddNote, onSelected,
  toggleActiveHighlight, selectedNote, onFocusAddTextarea, onDeleteNote, setOpenAddNote, openAddNote,
  noteText, onClearTextarea, onGetAddNoteText, onUpdateNote, changeHighlighModalPosition, refAddTextarea}}) => (
  <Fragment>
    <div className="Main__modal">
      <Colors onSelectedColor={onSelectedColor} selectedColor={selectedColor} onSetTextSelected={onSetTextSelected}
              onAddNote={onAddNote} onSelected={onSelected} toggleActiveHighlight={toggleActiveHighlight} isUpdate={true}
              selectedNote={selectedNote}/>
      <div className="add-btns">
        {selectedNote.note ?
          <p><button className="add-note-btn" onClick={() => {setOpenAddNote('openEditNote');onFocusAddTextarea()}}>{getLocaleString('reader.editNote')}</button></p> :
          <p><button className="add-note-btn" onClick={() => {setOpenAddNote('openAddNote');onFocusAddTextarea()}}>+ {getLocaleString('reader.addNote')}</button></p>
        }
      </div>
      <div className="delete-btns">
        <button className="delete-note-btn" onClick={() => {toggleActiveHighlight(false); onDeleteNote(selectedNote, true)}}>{getLocaleString('reader.deleteHighlight')}</button>
      </div>
    </div>
    <div className="Second__modal">
      <div className="Second__modal-header Dropdown__header">
        <span className="Second__modal-header-text">
          {getLocaleString('reader.addNote')}
        </span>
        <button className={`btn btn-add-note icon-btn${noteText.trim().length === 0 ? ' hide' : ''}`} onClick={() => createNote(onUpdateNote, noteText, onSelected, changeHighlighModalPosition,
          setOpenAddNote, openAddNote, onClearTextarea, toggleActiveHighlight)}></button>
        <button className="btn btn-close-white icon-btn" onClick={() => {onClearTextarea();setOpenAddNote(!openAddNote);onClearTextarea()}}></button>
      </div>
      <div className="Second__modal-content">
        <Scrollbars style={{ width: 235, height: 130 }}>
          <textarea ref={(c) => refAddTextarea(c)} id="add-note-text" className="add-note-text" onChange={() => onGetAddNoteText()}></textarea>
        </Scrollbars>
      </div>
    </div>
  </Fragment>
)

const PopupContent = ({openAddNote, props}) => cond([
  [equals('openEditNote'), always(<OpenEditNote props={props}/>)],
  [equals('openEditHighlight'), always(<OpenEditHighlight props={props}/>)],
  [T, always(<MainContent props={props}/>)]
])(openAddNote)

export class View extends React.Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    prevProps.resize()
  }

  render() {
    const {props, props: { active, highlightModalTop, highlightModalLeft, openAddNote }} = this

    return (
      <div id="HighlightModal__wrapper" style={{top: highlightModalTop + 'px', left: highlightModalLeft + 'px'}}
           className={`HighlightModal__wrapper${ active ? ' show' : ''} ${openAddNote}`}>
        <PopupContent openAddNote={openAddNote} props={props}/>
      </div>
    )
  }
}

export const HighlightModal = enhance(View)



// WEBPACK FOOTER //
// ./src/components/Reader/components/HighlighModal/HighlightModal.js